<ng-container *transloco="let t; scope: 'uiComponents'">
  <div class="bd-searchable-menu" data-id="searchable-menu">
    <div class="bd-searchable-menu-search">
      <bd-searchbar
        [placeholderText]="searchPlaceholder()"
        [searchTerm]="searchTerm()"
        (submitTypeAheadSearch)="onSearchChange($event)"
        (clearSearch)="onSearchClear()"
      ></bd-searchbar>
    </div>

    <ng-template #itemSkeleton>
      <div
        class="flex items-center bd-searchable-menu-item bd-searchable-menu-item-skeleton"
      >
        <p-skeleton
          width="1rem"
          height="1rem"
          borderRadius="2px"
          styleClass="bd-searchable-menu-item-skeleton-icon"
        />
        <p-skeleton
          width="7.5rem"
          height="1rem"
          borderRadius="2px"
          styleClass="bd-searchable-menu-item-skeleton-label"
        />
      </div>
    </ng-template>

    <ng-template #itemAnchor let-item>
      <ng-template #previewTooltip>
        @let preview = item.preview$ ? (item.preview$ | async) : null;
        <div class="bd-searchable-menu-preview-frame">
          @if (preview) {
            <img
              class="bd-searchable-menu-preview-image"
              [src]="preview"
              alt=""
            />
          }
        </div>
      </ng-template>
      <a
        class="flex items-center bd-searchable-menu-item"
        role="button"
        [attr.tabindex]="item.disabled ? -1 : 0"
        [attr.aria-disabled]="item.disabled ? true : null"
        [attr.data-id]="item.id ?? item.labelKey ?? item.label"
        [pTooltip]="item.preview$ ? previewTooltip : undefined"
        tooltipPosition="right"
        tooltipStyleClass="bd-searchable-menu-preview-tooltip"
        [tooltipDisabled]="previewTooltipsDisabled()"
        (click)="onItemClick($event, item)"
        (keydown.enter)="onItemClick($event, item)"
        (keydown.space)="$event.preventDefault(); onItemClick($event, item)"
      >
        @if (item.icon) {
          <i class="bd-searchable-menu-item-icon" [class]="item.icon"></i>
        }
        <span class="bd-searchable-menu-item-label">{{
          item.label ?? ''
        }}</span>
      </a>
    </ng-template>

    <div class="bd-searchable-menu-content bd-small-scrollbar">
      @if (showTopItems()) {
        <div
          class="bd-searchable-menu-section bd-searchable-menu-top-items-gutter"
          data-id="searchable-menu-top-items"
        >
          @if (topItemsTitle()) {
            <div
              class="bd-searchable-menu-section-title"
              data-id="searchable-menu-top-items-title"
            >
              {{ topItemsTitle() }}
            </div>
          }
          @for (item of topItems(); track item.id) {
            <ng-container
              *ngTemplateOutlet="itemAnchor; context: { $implicit: item }"
            ></ng-container>
          }
        </div>
        <p-divider class="bd-searchable-menu-divider" />
      } @else if (showTopItemsLoading()) {
        <div
          class="bd-searchable-menu-section bd-searchable-menu-top-items-gutter"
          data-id="searchable-menu-top-items-loading"
        >
          @if (topItemsTitle()) {
            <div
              class="bd-searchable-menu-section-title"
              data-id="searchable-menu-top-items-title"
            >
              {{ topItemsTitle() }}
            </div>
          }
          @for (row of topItemsSkeletonRows; track row) {
            <ng-container *ngTemplateOutlet="itemSkeleton"></ng-container>
          }
        </div>
        <p-divider class="bd-searchable-menu-divider" />
      }

      <div
        #scrollContainer
        class="bd-searchable-menu-section bd-searchable-menu-scroll"
        data-id="searchable-menu-all-items"
      >
        @for (item of filteredAllItems(); track item.id) {
          <ng-container
            *ngTemplateOutlet="itemAnchor; context: { $implicit: item }"
          ></ng-container>
        }
        @if (allItemsSkeletonRows().length > 0) {
          <div data-id="searchable-menu-all-items-loading">
            @for (row of allItemsSkeletonRows(); track row) {
              <ng-container *ngTemplateOutlet="itemSkeleton"></ng-container>
            }
          </div>
        } @else if (showEmptyState()) {
          @if (isSearching()) {
            <div
              class="bd-searchable-menu-empty"
              data-id="searchable-menu-empty-state"
            >
              {{ t('uiComponents.navigation.noResultsFound') }}
            </div>
          } @else if (noItemsText()) {
            <div
              class="bd-searchable-menu-empty"
              data-id="searchable-menu-no-items"
            >
              {{ noItemsText() }}
            </div>
          }
        }
      </div>
    </div>

    @if (footerAction() | translateActionButton | async; as footerButton) {
      <div class="bd-searchable-menu-footer">
        <p-button
          [bdActionButton]="footerButton"
          (onClick)="onFooterActionClick($event, footerButton)"
          data-id="searchable-menu-footer-action"
        ></p-button>
      </div>
    }
  </div>
</ng-container>
